<template>
  <div class="app-engine-menu">
    <div v-if="oneLevelMenus.length > 0" class="menu-group" :style="calcStyle">
      <menu-panel key="oneLevelMenus" :menuList="oneLevelMenus" @select="handleSelect"></menu-panel>
    </div>
    <template v-for="group in menuGroup">
      <menu-group :key="group.id" :group="group" @select="handleSelect"></menu-group>
    </template>
    <template v-if="isEmpty">
      <x-empty></x-empty>
    </template>
  </div>
</template>

<script>
import apis from '@/api'
import MenuPanel from '@/components/menu-panel/menu-panel'
import MenuGroup from '@/components/menu-group/menu-group'

export default {
  components: {
    MenuPanel,
    MenuGroup
  },
  data() {
    return {
      menuTree: []
    }
  },
  computed: {
    menuGroup() {
      return this.menuTree.filter(menu => menu.menuType === 'GROUP')
    },
    oneLevelMenus() {
      return this.menuTree.filter(menu => menu.menuType === 'MENU' || menu.menuType === 'REPORT')
    },
    isEmpty() {
      return this.menuGroup.length === 0 && this.oneLevelMenus.length === 0
    },
    calcStyle() {
      return {
        borderWidth: this.menuGroup.length > 0 ? '1px' : 0
      }
    }
  },
  watch: {
    '$route.query.appId': {
      handler(newVal, oldVal) {
        newVal && this.queryAppMenu(newVal)
      },
      immediate: true
    }
  },
  methods: {
    queryAppMenu(appId) {
      const request = {
        ...apis.APP_PAGE.APP_ENGINE_HOME_GET_MENU_TREE,
        params: {
          appId
        }
      }
      // this.$loading.show()
      this.$request(request).asyncThen(resp => {
        this.$loading.hide()
        if (resp.code === 'ok') {
          this.menuTree = resp.data
        }
      }, (err) => {
        this.$loading.hide()
      }).asyncErrorCatch((err) => {
        this.$loading.hide()
      })
    },
    handleSelect(menu) {
      console.log(menu)
      if (menu.menuType === 'REPORT') {
        this.$router.push({
          name: 'appAnalyse',
          query: {
            title: menu.menuName,
            formId: menu.formId,
            appId: this.$route.query.appId,
            currentMenu: menu.id
          }
        })
      } else if (menu.menuType === 'MENU') {
        this.$router.push({
          name: 'appList',
          query: {
            title: menu.menuName,
            formId: menu.formId,
            appId: this.$route.query.appId,
            processId: menu.processId,
            currentMenu: menu.id
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
.app-engine-menu {
  padding: 1.14rem;
  height: 100%;
  overflow-y: auto;
  box-sizing: border-box;
  .x-empty {
    margin: 40% auto;
  }
}
</style>
